import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { ModalService } from '@rocketfinancialcorp/rocket-ui/modal';
import { ModalsActions } from './modals.actions';

export const dismissAllModals$ = createEffect(
  (actions$ = inject(Actions), modalService = inject(ModalService)) => {
    return actions$.pipe(
      ofType(ModalsActions.dismissAll),
      map(() => modalService.dismissAll()),
    );
  },
  { functional: true, dispatch: false },
);
